define('appkit/controller.service',['require','exports','module','underscore','marionette','backbone.radio','backbone','./router','./service.util','bluebird'],function(require, exports, module) {
  var _           = require('underscore');
  var Mn          = require('marionette');
  var Radio       = require('backbone.radio');
  var Backbone    = require('backbone');
  var Router      = require('./router');
  var ServiceUtil = require('./service.util');
  var Promise     = require('bluebird');

  var ControllerService = {

    configurationChannelName: 'AppKit.controllerServiceConfiguration',

    channelName: 'AppKit.controllerService',

    radioRequests: {
      'addController'            : 'addController',
      'state'                    : 'getCurrentState',
      'controller'               : 'getCurrentController',
      'setCurrentController'     : 'setCurrentController',
      'routeName'                : 'getCurrentRouteName',
      'updateRouteName'          : 'setCurrentRouteName',
      'region'                   : 'getRegion',
      'resource'                 : 'getResource',
      'registerStartInterceptor' : 'registerStartInterceptor'
    },

    radioEvents: {
      'app configure': 'onAppConfigure'
    },

    options: {
      region: ServiceUtil.REQUIRED_OPTION,
      controllerChannelName: 'controllers',
      router: new Router()
    },

    currentRouteName: null,
    channel: Radio.channel('AppKit.controllerService'),

    onAppConfigure: function(app) {
      this.app = app;
      ServiceUtil.mergeRadioOptions(this);
    },

    registerStartInterceptor: function() {
      if (this.currentController) {
        return this.currentController
            .registerStartInterceptor.apply(this.currentController, arguments);
      }
    },

    route: function(routePath, routeName, controllerName, stateDefaults) {
      var controllerClass = Radio.channel(this.options.controllerChannelName).request(controllerName);
      if (controllerClass) {
        this.addController(routePath, routeName, controllerClass, stateDefaults);
      } else {
        Promise.reject(new Error('No controller found by the name "' + controllerName + '"'));
      }
      return this;
    },

    addController: function(routePath, routeName, controllerClass, stateDefaults) {
      var self = this;
      var router = this.getRouter();
      router.route(routePath, routeName, function(params) {
        self.setCurrentRouteName(routeName);
        try {
          self.invokeController(controllerClass, routeName, _.extend({},
            Mn._getValue(stateDefaults, self),
            params
          ));
        } catch (e) {
          Promise.reject(e);
        }
      });
      return this;
    },

    invokeController: function(controllerClass, routeName, params) {
      try {
        var state = this.createStateModel(params);

        this.channel.trigger('before:change:state', this.currentState);
        this.app.state = state;
        this.currentState = state;
        this.bindStateChangesToRoutePath(state);
        this.channel.trigger('change:state', state);

        var controller = this.buildController(controllerClass, {
          app: this.app,
          region: this.getRegion(),
          state: state
        });

        this.channel.trigger('before:start', controller);
        controller.start();
        this.setCurrentController(controller);
        this.channel.trigger('start', controller);
        
      } catch (e) {
        if (controller) {
          controller.stop();
        }
        throw e;
      }
      return controller;
    },

    cleanupCurrentController: function() {
      if (this.currentController) {
        this.currentController.stop();
      }
      this.currentController = null;
    },

    createStateModel: function(params) {
      return new Backbone.Model(params);
    },

    buildController: function(Controller, options) {
      return new Controller(options);
    },

    bindStateChangesToRoutePath: function(state) {
      state.on('change', function() {
        var routeName = this.getCurrentRouteName();
        var router = this.getRouter();
        router._updateRoute(routeName, state);
      }, this);
    },

    getCurrentState: function() {
      return this.currentState;
    },

    setCurrentController: function(controller) {
      if (controller !== this.currentController) {
        this.cleanupCurrentController();
        this.currentController = controller
      }
      return this;
    },

    getCurrentController: function() {
      return this.currentController;
    },

    getRouter: function() {
      return this.options.router;
    },

    getRegion: function() {
      return this.options.region;
    },

    getCurrentRouteName: function() {
      return this.currentRouteName;
    },

    setCurrentRouteName: function(routeName) {
      this.currentRouteName = routeName;
    },

    getResource: function(name) {
      return Radio.request('AppKit.resourceService', 'resource', name);
    }

  };

  module.exports = ControllerService;
});

